'use client'

import CityFormField from '@tebuto/forms/CityFormField'
import FormField from '@tebuto/forms/Field'
import StreetFormField from '@tebuto/forms/StreetFormField'
import ZipFormField from '@tebuto/forms/ZipFormField'
import { useComponentTranslation } from '@tebuto/functions/translation.components'
import { cn } from '@tebuto/lib/utils'
import { useContext } from 'react'
import { BookingWidgetContext } from './context'
import { WidgetAuthContext } from './widget-auth'

export default function PersonalDataFields() {
    const { t } = useComponentTranslation()
    const { requirePhoneNumber, requireAddress, requireBirthdate } = useContext(BookingWidgetContext)
    const { apiUrl } = useContext(WidgetAuthContext)
    return (
        <div className="grid gap-10">
            <PersonalDataSection heading={requireAddress ? 'Allgemein' : undefined}>
                <div className="grid gap-6 w-full md:grid-cols-2">
                    <FormField
                        name={'firstName'}
                        fieldClassName="widget-bg-field widget-border widget-text-primary"
                        labelClassName="widget-text-secondary"
                        label={t('firstName')}
                        mandatory={true}
                        autoComplete={'given-name'}
                    />
                    <FormField
                        name={'lastName'}
                        fieldClassName="widget-bg-field widget-border widget-text-primary"
                        labelClassName="widget-text-secondary"
                        label={t('lastName')}
                        mandatory={true}
                        autoComplete={'family-name'}
                    />
                    <FormField
                        name="email"
                        label={t('yourEmailAddress')}
                        type="text"
                        placeholder="email@example.com"
                        autoComplete="email"
                        fieldClassName="widget-bg-field widget-border widget-text-primary"
                        className={cn(requirePhoneNumber ? '' : 'col-span-2')}
                        labelClassName="widget-text-secondary"
                        mandatory
                    />
                    {requirePhoneNumber && (
                        <FormField
                            name="phoneNumber"
                            label={t('phoneNumber')}
                            type="text"
                            placeholder="+49 123 456789"
                            autoComplete="tel"
                            fieldClassName="widget-bg-field widget-border widget-text-primary"
                            labelClassName="widget-text-secondary"
                            mandatory
                        />
                    )}
                    {requireBirthdate && (
                        <FormField
                            name="birthdate"
                            label={t('birthdate')}
                            type="date"
                            autoComplete="bday"
                            max={new Date().toISOString().slice(0, 10)}
                            fieldClassName="widget-bg-field widget-border widget-text-primary"
                            labelClassName="widget-text-secondary"
                            mandatory
                        />
                    )}
                </div>
            </PersonalDataSection>

            {requireAddress && (
                <PersonalDataSection heading={t('address')}>
                    <div className="grid gap-6">
                        <StreetFormField
                            label={'Straße und Hausnummer'}
                            name={'address.streetAndNumber'}
                            zipFieldName={'address.city.zip'}
                            cityFieldName={'address.city.name'}
                            lookupBaseUrl={apiUrl}
                            autoComplete="street-address"
                            mandatory
                            fieldClassName="widget-bg-field widget-border widget-text-primary"
                            labelClassName="widget-text-secondary"
                        />
                        <div className="flex gap-6">
                            <ZipFormField
                                fieldClassName="widget-bg-field widget-border widget-text-primary"
                                label={'Postleitzahl'}
                                name={'address.city.zip'}
                                cityFieldName={'address.city.name'}
                                lookupBaseUrl={apiUrl}
                                autoComplete="postal-code"
                                className="w-20 grow-0"
                                mandatory
                                labelClassName="widget-text-secondary"
                            />
                            <CityFormField
                                label={'Stadt'}
                                name={'address.city.name'}
                                zipFieldName={'address.city.zip'}
                                lookupBaseUrl={apiUrl}
                                autoComplete="address-level2"
                                fieldClassName="widget-bg-field widget-border widget-text-primary"
                                className="grow"
                                labelClassName="widget-text-secondary"
                                mandatory
                            />
                        </div>
                    </div>
                </PersonalDataSection>
            )}
        </div>
    )
}

function PersonalDataSection({ heading, children }: { heading?: string; children: React.ReactNode }) {
    return (
        <div className="grid gap-6 xs:gap-4">
            {heading && <h3 className="text-base xs:text-lg font-medium widget-text-primary">{heading}</h3>}
            {children}
        </div>
    )
}
